﻿// ui.js

function handleIsCreditSwitch(e) {

    const icon = e.target.closest('.isCreditSwitch');
    if (!icon) return;

    const hiddenInput = icon.previousElementSibling;
    const isCredit = hiddenInput.value.toLowerCase() === 'true';

    switch (e.type) {

        case 'mouseout':
            icon.className = `bi ${isCredit ? 'bi-plus-circle text-success' : 'bi-dash-circle text-danger'} isCreditSwitch h5`;
            break;

        case 'mouseover':
            icon.className = `bi ${isCredit ? 'bi-plus-circle-fill text-success' : 'bi-dash-circle-fill text-danger'} isCreditSwitch h5`;
            break;

        case 'click':
            icon.className = `bi ${isCredit ? 'bi-dash-circle-fill text-danger' : 'bi-plus-circle-fill text-success'} isCreditSwitch h5`;
            hiddenInput.value = String(!isCredit);
            break;
    }
}

function initIsCreditSwitch() {
    const events = ['click', 'mouseover', 'mouseout'];
    const parents = ['#newAccountEventDiv', '#accountEventEditModal', '#accountCreationForm'];

    parents.forEach(selector => {
        const parent = document.querySelector(selector);
        if (!parent) return;
        events.forEach(type => parent.addEventListener(type, handleIsCreditSwitch));
    })
}

function initTogglePassword() {
    document.querySelectorAll('.togglePassword').forEach(btn => {
        btn.addEventListener('click', () => {
            const input = document.querySelector('.password');
            if (!input) return;
            input.type = input.type === 'password' ? 'text' : 'password';
            btn.classList.toggle('bi-eye');
            btn.classList.toggle('bi-eye-slash');
        })
    })
}

function updateSignIcon(value) {
    const icon = document.querySelector('#accountBalanceSignIcon');
    if (!icon) return;
    icon.classList.toggle('bi-plus', value >= 0);
    icon.classList.toggle('bi-dash', value < 0);
}

function accountBalanceUpdateAnimation() {

    const euroFormat = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
    const animationDuration = 300;

    document.querySelectorAll('.balanceCounter').forEach(counter => {
        const newBalance = parseFloat(counter.dataset.currentValue);
        const previousBalance = parseFloat(counter.dataset.previousValue);

        if (isNaN(newBalance) || isNaN(previousBalance) || newBalance === previousBalance) return;

        const startTime = performance.now();

        const animate = (currentTime) => {
            const progress = Math.min((currentTime - startTime) / animationDuration, 1);
            const currentValue = previousBalance + (newBalance - previousBalance) * progress;

            counter.innerHTML = euroFormat.format(Math.abs(currentValue));
            updateSignIcon(currentValue);

            if (progress < 1) requestAnimationFrame(animate);
        };
        requestAnimationFrame(animate);
    })
}

export {

    initTogglePassword,
    initIsCreditSwitch,
    accountBalanceUpdateAnimation
};